/* Saveurs Marines — fiche produit V2 (sans dépendance) */
(function () {
  'use strict';

  function money(cents) {
    var c = Math.round(cents || 0);
    var e = Math.floor(c / 100);
    var r = c % 100;
    return e + ',' + (r < 10 ? '0' + r : r) + ' €';
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshCartBubble() {
    return fetch(shopRoot() + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target || !data['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) target.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  function addToCart(id, quantity) {
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw new Error(json.description || json.message || 'Ajout impossible');
        return json;
      });
    });
  }

  function updateShip(total) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sm-ship]'), function (el) {
      var limit = Number(el.getAttribute('data-threshold')) || 0;
      if (!limit) return;
      var left = limit - total;
      var text = el.querySelector('[data-sm-ship-text]');
      var bar = el.querySelector('[data-sm-ship-bar]');
      if (text) text.innerHTML = left > 0 ? 'Plus que <strong>' + money(left) + '</strong> pour la livraison offerte' : '<strong>La livraison est offerte</strong> ✓';
      if (bar) bar.style.width = Math.min(100, Math.round((total / limit) * 100)) + '%';
    });
  }

  function refreshShip() {
    if (!document.querySelector('[data-sm-ship]')) return Promise.resolve();
    return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateShip(cart.total_price || 0); })
      .catch(function () {});
  }

  function afterAdd() {
    return Promise.all([refreshCartBubble(), refreshShip()]);
  }

  function ctaLabel(price) {
    return 'Ajouter<span class="sm-cta__long"> au panier</span> — ' + money(price);
  }

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-sm-product-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent).variants;
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-sm-option]'));
    var idInput = root.querySelector('[data-sm-variant-id]');
    var form = root.querySelector('[data-sm-form]');
    var cta = root.querySelector('[data-sm-cta]');
    var errorEl = root.querySelector('[data-sm-error]');
    var addedEl = root.querySelector('[data-sm-added]');
    var qtyInput = root.querySelector('[data-sm-qty-input]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sm-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sm-thumb]'));

    function showSlide(index) {
      if (!slides[index]) return;
      slides.forEach(function (s, i) { s.hidden = i !== index; s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { if (i === index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(Number(t.getAttribute('data-sm-thumb'))); });
    });

    function selection() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var k = 0; k < opts.length; k++) {
          if (v.options[k] !== opts[k]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var opts = selection();
      var v = findVariant(opts);

      fieldsets.forEach(function (fs, oi) {
        var varies = fs.getAttribute('data-varies') === 'true';
        var isList = fs.classList.contains('sm-option--list');
        Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (input) {
          var trial = opts.slice();
          trial[oi] = input.value;
          var match = findVariant(trial);
          var label = root.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          label.classList.toggle('is-unavailable', !match || !match.available);
          var priceEl = label.querySelector('[data-sm-choice-price]');
          if (priceEl && varies) priceEl.textContent = match ? money(match.price) : '—';
          var metaEl = label.querySelector('[data-sm-choice-meta]');
          if (metaEl) {
            var parts = [];
            if (isList && match && match.unit) parts.push(match.unit);
            if (match && !match.available) parts.push('épuisé');
            metaEl.textContent = parts.join(' · ');
          }
        });
      });

      if (addedEl) addedEl.classList.remove('is-visible');
      if (!v) {
        cta.disabled = true;
        cta.textContent = 'Combinaison indisponible';
        return;
      }

      idInput.value = v.id;
      Array.prototype.forEach.call(root.querySelectorAll('[data-sm-price]'), function (el) { el.textContent = money(v.price); });
      var unitEl = root.querySelector('[data-sm-unit]');
      if (unitEl) unitEl.textContent = v.unit || '';
      var cmp = root.querySelector('[data-sm-compare]');
      if (cmp) cmp.textContent = v.compare > v.price ? money(v.compare) : '';

      if (v.available) {
        cta.disabled = false;
        cta.innerHTML = ctaLabel(v.price);
      } else {
        cta.disabled = true;
        cta.textContent = 'Épuisé pour le moment';
      }

      if (v.media !== null && v.media !== undefined) showSlide(v.media);

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    Array.prototype.forEach.call(root.querySelectorAll('[data-sm-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-sm-qty'));
        qtyInput.value = Math.min(20, Math.max(1, n));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      cta.classList.add('is-loading');
      errorEl.hidden = true;
      addToCart(idInput.value, qtyInput.value)
        .then(function () {
          addedEl.classList.add('is-visible');
          return afterAdd();
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        })
        .then(function () { cta.classList.remove('is-loading'); });
    });

    var sticky = root.querySelector('[data-sm-sticky]');
    var stickyCta = root.querySelector('[data-sm-sticky-cta]');
    if (sticky && stickyCta && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        stickyCta.tabIndex = visible ? 0 : -1;
      });
      io.observe(cta);
      stickyCta.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else cta.click();
      });
    }
  }

  function initExtras() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sm-extra]'), function (btn) {
      if (btn.dataset.smBound) return;
      btn.dataset.smBound = '1';
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-added')) return;
        btn.disabled = true;
        addToCart(btn.getAttribute('data-sm-extra'), 1)
          .then(function () {
            if (btn.closest('[data-sm-reload]')) { window.location.reload(); return; }
            btn.classList.add('is-added');
            btn.textContent = 'Ajouté ✓';
            return afterAdd();
          })
          .catch(function () { btn.textContent = 'Indisponible'; })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  function watchDawnCart() {
    if (window.__smShipWatch) return;
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          var data = event && event.cartData;
          if (data && typeof data.total_price === 'number') updateShip(data.total_price); else refreshShip();
        });
        window.__smShipWatch = true;
      }
    } catch (e) {}
  }

  window.smInitExtras = initExtras;

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sm-product-root]'), function (root) {
      if (root.dataset.smBound) return;
      root.dataset.smBound = '1';
      initProduct(root);
    });
    initExtras();
    watchDawnCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
